module.exports = __webpack_public_path__ + "static/media/dot-icon.aae824fb.svg";